import {FC, useState} from 'react';
import {Box, IconButton, useMediaQuery} from '@mui/material';
import {ReactComponent as Menu} from '@icons/brg-menu.svg';
import {ReactComponent as Notification} from '@icons/notification-new.svg';
import ActionUserNotLogined from '@/components/User/ActionUserNotLogined';
import UserDropdown from './UserDropdown';
import {useSelector} from 'react-redux';
import {getUserSelector} from '@/store/user';
import {userHeaderStyle} from './UserHeader.styles';
import NotificationPopup from '@/layouts/OrganizationTemplate/OrganizationHeader/OrganizationNotificationPopup';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import {ROUTER_URL} from '@/utils/enums';
import MobMenu from '../MobMenu';
import {unreadNotificationSelector} from '@/store/notification';
import {getCurrentEventSelector} from '@/store/organization-event';
import {ReactComponent as ArrowIcon} from '@icons/arrow-left.svg';

const UserHeader: FC = () => {
  const {slug} = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector(getUserSelector);
  const event = useSelector(getCurrentEventSelector);

  const {notifications: unreadNotifications} = useSelector(unreadNotificationSelector);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isLaptop = useMediaQuery('(min-width: 1200px)');
  const isMobile = useMediaQuery('(max-width: 767.98px)');

  const handleMobMenuClick = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewAllClick = () => {
    navigate(ROUTER_URL.USER_NOTIFICATIONS);
    handleClose();
  };

  const open = !!anchorEl;
  const id = open ? 'simple-popover' : undefined;

  const isFundMissions = location.pathname.includes('/fundMissions');

  return (
    <Box sx={userHeaderStyle.header}>
      <Box sx={userHeaderStyle.panel}>
        {/* <> */}
        {(!isMobile || (isMobile && !user)) && (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
            {isFundMissions && isLaptop && <Box sx={{cursor: 'pointer', padding: 2}} onClick={() => navigate(-1)}><ArrowIcon /></Box>}
            <Link
              to={`/${slug}`}
              onClick={() => setIsMobileMenuOpen(false)}
              style={{display: 'flex', alignItems: 'center'}}
            >
              {event?.organization.logo ? (
                <img
                  src={event.organization.logo}
                  alt={`${event.organization.name ?? 'Organization'} logo`}
                  style={{
                    height: 44,
                    width: 'auto',
                    maxWidth: 120,
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              ) : null}
            </Link>
          </Box>
        )}
        {/* </> */}

        <Box sx={{...userHeaderStyle.actions, ...(isMobile && !user && {flexDirection: 'row-reverse'})}}>
          {!user && (
            <Box sx={userHeaderStyle.btnWrapper}>
              <ActionUserNotLogined title="Login" parentClassName={{height: '44px'}} />
            </Box>
          )}

          {user && (
            <Box sx={userHeaderStyle.content}>
              <IconButton aria-describedby={id} sx={userHeaderStyle.button} onClick={handleClick}>
                {unreadNotifications.length > 0 ? (
                  <Notification />
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="notification">
                      <path
                        d="M12.0199 20.5302C9.68987 20.5302 7.35987 20.1602 5.14987 19.4202C4.30987 19.1302 3.66987 18.5402 3.38987 17.7702C3.09987 17.0002 3.19987 16.1502 3.65987 15.3902L4.80987 13.4802C5.04987 13.0802 5.26987 12.2802 5.26987 11.8102V8.92018C5.26987 5.20018 8.29987 2.17018 12.0199 2.17018C15.7399 2.17018 18.7699 5.20018 18.7699 8.92018V11.8102C18.7699 12.2702 18.9899 13.0802 19.2299 13.4902L20.3699 15.3902C20.7999 16.1102 20.8799 16.9802 20.5899 17.7702C20.2999 18.5602 19.6699 19.1602 18.8799 19.4202C16.6799 20.1602 14.3499 20.5302 12.0199 20.5302ZM12.0199 3.67018C9.12987 3.67018 6.76987 6.02018 6.76987 8.92018V11.8102C6.76987 12.5402 6.46987 13.6202 6.09987 14.2502L4.94987 16.1602C4.72987 16.5302 4.66987 16.9202 4.79987 17.2502C4.91987 17.5902 5.21987 17.8502 5.62987 17.9902C9.80987 19.3902 14.2399 19.3902 18.4199 17.9902C18.7799 17.8702 19.0599 17.6002 19.1899 17.2402C19.3199 16.8802 19.2899 16.4902 19.0899 16.1602L17.9399 14.2502C17.5599 13.6002 17.2699 12.5302 17.2699 11.8002V8.92018C17.2699 6.02018 14.9199 3.67018 12.0199 3.67018Z"
                        fill="#0C1525"
                      />
                      <path
                        d="M13.8795 3.94018C13.8095 3.94018 13.7395 3.93018 13.6695 3.91018C13.3795 3.83018 13.0995 3.77018 12.8295 3.73018C11.9795 3.62018 11.1595 3.68018 10.3895 3.91018C10.1095 4.00018 9.80949 3.91018 9.61949 3.70018C9.42949 3.49018 9.36949 3.19018 9.47949 2.92018C9.88949 1.87018 10.8895 1.18018 12.0295 1.18018C13.1695 1.18018 14.1695 1.86018 14.5795 2.92018C14.6795 3.19018 14.6295 3.49018 14.4395 3.70018C14.2895 3.86018 14.0795 3.94018 13.8795 3.94018Z"
                        fill="#0C1525"
                      />
                      <path
                        d="M12.0194 22.8102C11.0294 22.8102 10.0694 22.4102 9.3694 21.7102C8.6694 21.0102 8.2694 20.0502 8.2694 19.0602H9.7694C9.7694 19.6502 10.0094 20.2302 10.4294 20.6502C10.8494 21.0702 11.4294 21.3102 12.0194 21.3102C13.2594 21.3102 14.2694 20.3002 14.2694 19.0602H15.7694C15.7694 21.1302 14.0894 22.8102 12.0194 22.8102Z"
                        fill="#0C1525"
                      />
                    </g>
                  </svg>
                )}
              </IconButton>
              <NotificationPopup
                id={id}
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                handleLinkClick={handleViewAllClick}
              />
              <UserDropdown />
            </Box>
          )}

          {!isLaptop && (
            <IconButton onClick={handleMobMenuClick}>
              <Menu />
            </IconButton>
          )}
        </Box>
      </Box>
      {isMobileMenuOpen && <MobMenu onClose={handleMobMenuClick} />}
    </Box>
  );
};

export default UserHeader;
